/* Import Styles */
import '@/scss/app.scss';

import Vue from 'vue';
import VueCookies from 'vue-cookies';
import i18n from '@/translations';

import '@/utils/centios/index';

import App from './App.vue';
import router from './router';
import store from './store';

/* Import Helio */
import Helio from '../centiva-design-system/src/components';

/* Instantiate i18n */
window.i18n = i18n;
Vue.use(i18n);

/* Instantiate Centiva Design System */
Vue.use(Helio, {
	components: [
		'Button',
		'Field',
		'Message',
		'Icon',
		'Toast',
		'Slider',
	],
});

/* Instantiate Vue Cookie */
Vue.use(VueCookies);

/* Instantiate Vue and it's configs */
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');
